/*
 * @Copyright: 中国信息安全测评中心
 * @Author: xiaowenwen
 * @Date: 2021-03-02 11:50:32
 * @LastEditTime: 2022-08-22 18:08:04
 * @Description:
 */
/**
 * JavaScript Document
 * Version: 1.0.0
 * Date: 9/25/2020
 * Author: Liu Changkun
 * Copyright: www.east.net
 */
export default {
  SandauApi: "杉达学院邮箱用户注册鉴权",
  hirain: "恒润定制化邮件列表同步规则",
  hirainApi: "可通过该接口重置网易邮箱密码",
  AccountDelete: "批量删除网易邮箱，可于7天内找回, 超时邮箱彻底删除",
  SusApi: "上海体院校园系统可通过该接口查询邮箱初始密码",
  aliasManager: "批量管理网易邮箱别名，可对别名进行增删改查",
  EmailNotifier: "开启/关闭中间件系统的异常通知",
  GeneralDynamicMaillist:
    "通过自定义规则生成网易邮件列表，列表内成员根据规则动态变更",
  GeneralUnitDynamicMaillist:
    "通过部门生成网易邮件列表，列表内成员根据部门成员动态变更",
  GeneralTaskTimer: "管理全部扩展组件的自动执行周期",
  MaillistPermReset: "批量管理网易邮件列表的使用权限",
  PasswordExpireReminder: "对于AD密码即将到期的用户发送邮件提醒",
  passwordReset: "批量重置网易邮箱用户密码",
  PermReset: "批量管理网易邮箱用户权限",
  SusTask: "对于长时间未登录的网易邮箱用户，关闭其登录权限",
  WorkWeiXinLogin: "允许用户在web端使用企业微信扫码登录网易邮箱",
  DingTalkLogin: "允许用户在web端使用钉钉扫码登录网易邮箱",
  FeishuApi: "允许用户在web端使用飞书扫码登录网易邮箱",
  PasswordReminderExtend: "对于邮箱密码即将到期的用户发送邮件提醒",
  BindingPhoneExtend: "为邮箱账号设置密保手机",
  ExtendDynamicMaillist: "为邮件列表扩展增加/减少列表成员",
  ADInfoWriteBack: "批量设置AD账号的属性",
  VerifyPhoneTask: "批量设置账号密保手机号及是否开启登陆时手机短信验证",
  CreateMail: "批量快速创建账号(数据单独设置, 不依赖于同步数据源)",
  DisableAccount: "批量禁用并移动账号至默认部门",
  DefaultSender: "批量设置账号默认发件人"
};
